import React, { useEffect, useState } from "react";
import { useJoinNowContext } from "../../Context/joinNowContext";
import axios from "axios";
import { toast } from "react-toastify";
import { CircularProgress, InputAdornment } from "@mui/material";

function ChoseMemberShip() {
  const [loading, setLoading] = useState(false);

  const {
    setPlanId,
    step,
    setStep,
    setSelectedPlan,
    selectedPlan,
    email,
    setMonth,
    first_name,
    last_name,
  } = useJoinNowContext();

  const MarkedSvg = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 30 30"
      className="mr-2"
    >
      <path d="M0 0h30v30H0z" fill="none" />
      <path
        d="m10.254 19.378-4.345-4.591a1.176 1.176 0 0 0-1.738 0 1.343 1.343 0 0 0 0 1.837l5.2 5.5a1.19 1.19 0 0 0 1.751 0L24.284 8.228a1.343 1.343 0 0 0 0-1.837 1.176 1.176 0 0 0-1.738 0z"
        transform="translate(1.027 1.093)"
        fill="#bbb"
        stroke="#bbb"
      />
    </svg>
  );
  const [hoveredPlan, setHoveredPlan] = useState<{
    planType: string;
    planName: string;
  } | null>(null);

  const handleButtonClick = async (data) => {
    const selectedPlanWithMonth = { ...data, month };
    const record = {
      email: email,
      first_name: first_name,
      last_name: last_name,
    };
    setLoading(true)
    try{
      console.log("this is loading",loading)
      await axios
      .post("https://portal.fitstreak.club/api/api/temp-user/sendOtp", {
        data: record,
      })
      .then((response) => {
        if (hoveredPlan) {
          setPlanId(data.memberShipId);
          setMonth(month);
          setSelectedPlan(selectedPlanWithMonth);
          setStep(step + 1);
        }
      }).catch((error)=>{
        console.log("this is error",error.message)
      })}
      catch (error){
        toast.error("An error occured");
      }
      finally{
        setLoading(false)
      }
  };

  const [membershipData, setMembershipData] = useState([]);
  useEffect(() => {
    
    try {
      
      axios
        .get("https://portal.fitstreak.club/api/api/membership")
        .then((response) => {
          setMembershipData(response.data);
        })
        .catch((error) => {
          console.log("errors", error.message);
        });
    } catch {
      console.log("this is error on getting membership");
    } finally {
      
    }
  }, []);
  const [planType, setPlanType] = useState("alpha");
  const [month, setMonths] = useState(1);

  const [planData, setPlanData] = useState([]);
  useEffect(() => {
    if (membershipData && membershipData.length > 0) {
      const filteredPlans = membershipData.filter(
        (data) =>
          data.membershipPlanName === planType &&
          data.memberShipName === "Basic"
      );
      setPlanData(filteredPlans);
    }
  }, [membershipData, planType]);

  return (
    <div className="w-[100%] lg:w-[100%] xl:w-[90%] 2xl:w-[80%] h-auto p-2  py-10 relative rounded-[10px]  z-10 bg-custom-gradient2  m-auto  aling-center justify-center">
      {loading && (
        <div
          className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 z-10"
        >
          <CircularProgress size="3rem" style={{ color: "red" }} />
        </div>
      )}
     <div className='flex flex-col md:flex-row p-1 w-[210px] md:w-[100%] lg:w-[95%] xl:w-[80%] 2xl:w-[65%] mt-4 md:mt-6 border border-[#3b3b3b] h-auto m-auto justify-between rounded-[4px]'>
        <div className={`${planType === 'alpha' ? 'bg-[#3b3b3b]' : 'bg-inherit'}  p-2 md:w-[30%] aling-center text-center  rounded-[4px] cursor-pointer `} onClick={() => {
          setPlanType('alpha')
        }}>
          <h1 className='text-md md:text-lg lg:text-xl text-white font-bold mt-[5%]  w-[90%] '>Alpha</h1>
          <p className='text-sm md:text-xs lg:text-sm  text-nav_option  w-[90%]'>Flexible plans for your individual
            fitness journey.</p>
        </div>
        <div className={`${planType === 'couple' ? 'bg-[#3b3b3b]' : 'bg-inherit'}  p-2 md:w-[30%] aling-center text-center rounded-[4px] cursor-pointer`} onClick={() => {
          setPlanType('couple')
        }} >
          <h1 className='text-md md:text-lg lg:text-xl text-white font-bold mt-[5%]  w-[90%] '>Couple</h1>
          <p className='text-sm md:text-xs lg:text-sm text-nav_option  w-[90%]'>Train together with our exclusive
            couple plans.</p>
        </div>
        <div className={`${planType === 'family' ? 'bg-[#3b3b3b]' : 'bg-inherit'}  p-2 md:w-[30%] aling-center text-center  rounded-[4px] cursor-pointer `} onClick={() => {
          setPlanType('family')
        }}>
          <h1 className='text-md md:text-lg lg:text-xl text-white font-bold mt-[5%]  w-[90%] '>Family</h1>
          <p className='text-sm md:text-xs lg:text-sm text-nav_option  w-[90%]'>Flexible plans for your individual
            fitness journey.</p>
        </div>
        <div className={`${planType === 'student' ? 'bg-[#3b3b3b]' : 'bg-inherit'}  p-2  md:w-[30%] aling-center text-center rounded-[4px] cursor-pointer`} onClick={() => {
          setPlanType('student')
        }} >
          <h1 className='text-md md:text-lg lg:text-xl text-white font-bold mt-[5%] w-[90%]'>Student</h1>
          <p className='text-sm md:text-xs lg:text-sm text-nav_option  w-[90%]'>Affordable plans tailored for
            students to stay fit.</p>
        </div>
        <div className={`${planType === 'hamaryhero' ? 'bg-[#3b3b3b]' : 'bg-inherit'}  p-2 md:w-[30%] aling-center text-center  rounded-[4px] cursor-pointer `} onClick={() => {
          setPlanType("hamaryhero")
        }}>
          <h1 className='text-md md:text-lg lg:text-xl text-white font-bold mt-[5%]  w-[90%] '>Hamary Hero</h1>
          <p className='text-sm md:text-xs lg:text-sm text-nav_option  w-[90%]'>Flexible plans for your individual
            fitness journey.</p>
        </div>
      </div>
      <div className="aling-center flex xxs:flex-col xxs:w-[150px] xxs:text-center w-max xss:w-max  m-auto border border-red rounded-[20px] mt-8 cursor-pointer">
        <div
          className={`${
            month === 1 ? "bg-red" : "bg-inherit"
          } px-3 py-1 md:px-6 md:py-2 rounded-[20px] `}
          onClick={() => setMonths(1)}
        >
          <p className="text-white text-bold  text-xs xs:text-base sm:text-lg">
            1 Month
          </p>
        </div>
        <div
          className={`${
            month === 3 ? "bg-red" : "bg-inherit"
          } px-3 py-1 md:px-6 md:py-2   rounded-[20px]  `}
          onClick={() => setMonths(3)}
        >
          <p className="text-white text-bold  text-xs xs:text-base sm:text-lg">
            3 Month
          </p>
        </div>
        <div
          className={`${
            month === 6 ? "bg-red" : "bg-inherit"
          } px-3 py-1 md:px-6 md:py-2   rounded-[20px]  `}
          onClick={() => setMonths(6)}
        >
          <p className="text-white text-bold  text-xs xs:text-base sm:text-lg">
            6 Month
          </p>
        </div>
        <div
          className={`${
            month === 12 ? "bg-red" : "bg-inherit"
          } px-3 py-1 md:px-6 md:py-2   rounded-[20px]  `}
          onClick={() => setMonths(12)}
        >
          <p className="text-white text-bold  text-xs xs:text-base sm:text-lg">
            12 Month
          </p>
        </div>
      </div>
      <div
        className={`h-auto w-[95%]  m-auto mt-8 justify-center 2xl:w-[88%] xxl:w-[75%] aling-center flex flex-col lg:flex-row `}
      >
        {planData.map((data, index) => (
          <div
            key={index}
            onMouseEnter={() =>
              setHoveredPlan({
                planType: data.membershipPlanName,
                planName: data.memberShipName,
              })
            }
            onMouseLeave={() => setHoveredPlan(null)}
            className={`transition-all duration-[200ms]
              ${loading === true ? 'h-[450px]' : 'h-[400px]'}
              ease ${
              hoveredPlan &&
              hoveredPlan.planType === planType &&
              hoveredPlan.planName === data.memberShipName
                ? "h-[450px]"
                : "h-[400px]"
            } w-[300px] xxs:w-[100%] mt-10  m-auto flex p-2 flex-col   md:w-[300px] lg:w-[320px] lg:m-0  xl:w-[323px] 2xl:w-[320px]   border border-[#474747] hover:border hover:border-red  bg-[#1c1c1c]  z-0 rounded-[10px] text-center aling-center justify-center  `}
          >
            <div className="mt-4 w-[80%] m-auto text-xl text-white decoration-none font-semibold mb-2">
              {data.memberShipName}
            </div>
            <div className="mt-4 w-[80%]  m-auto text-base text-nav_option decoration-none mb-2 text-left ">
              {data.memberShipDescription}
            </div>
            <div className="mt-4 w-max p-1 rounded-[4px] ml-[10%] bg-red text-xs lg:w-max px-2 xxs:text-xs xl:text-sm text-white decoration-none mb-2 item-left">
              {`the ${data.memberShipName} plan for ${planType} `}{" "}
            </div>
            <div className="mt-4 w-[80%] m-auto text-2xl xss:text-2xl xl:text-3xl font-bold text-white decoration-none mt-2 mb-2 text-left">
              {month === 1 &&
                `${Number(data.memberShipAmount).toLocaleString()} Rs`}
              {month === 3 &&
                `${Number(data.threeMonthAmount).toLocaleString()} Rs`}
              {month === 6 &&
                `${Number(data.sixMonthAmount).toLocaleString()} Rs`}
              {month === 12 &&
                `${Number(data.twelveMonthAmount).toLocaleString()} Rs`}

              <span className=" text-base lg:text-base xl:text-lg text-nav_option decoration-none">
                /{month === 1 ? "" : month}month
              </span>
            </div>
            {data.benefits.map((feature, index) => (
              <div
                key={index}
                className="mt-2 w-[80%] m-auto text-sm text-nav_option decoration-none flex items-center"
              >
                <span className="flex flex-row jusitify-between text-left">
                  <MarkedSvg />
                  {feature.benefit}
                </span>
              </div>
            ))}
         { hoveredPlan && hoveredPlan.planType === planType && hoveredPlan.planName === data.memberShipName && (
              <button
                className='w-[90%] m-auto p-2 bg-red text-white mt-4 rounded-[5px]'
                onClick={() => handleButtonClick(data)}
              >
                Choose This One
              </button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default ChoseMemberShip;
